import { Switch } from 'antd';
import Table from 'common/table/table';
import { ThemeHeader } from 'common/table/table-helper';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { SapId } from 'ui';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { withRouter } from 'utils/withRouter';

const EquipmentCount = styled.span`
  font-size: 0.85em;
  font-weight: 300;
  margin-left: 8px;
`;

const Filter = styled.span`
  font-size: 0.85em;
  font-weight: 300;
  margin-left: 36px;
`;

const StyledSwitch = styled(Switch)`
  margin-left: 10px;
`;

const Wrapper = styled.div`
  background-color: #fff;
`;

const InstalledAtsTable = ({
  isLoading,
  installedAts = [],
  equipmentCount,
  intl,
  history,
  activeRow,
}) => {
  const [data, setData] = useState([]);
  const [showEmptyEquipment, setShowEmptyEquipment] = useState(false);

  useDeepCompareEffect(() => {
    setData(showEmptyEquipment ? installedAts : installedAts?.filter(ia => ia.equipmentCount > 0));
  }, [installedAts]);

  useEffect(() => {
    setData(showEmptyEquipment ? installedAts : installedAts?.filter(ia => ia.equipmentCount > 0));
  }, [showEmptyEquipment]);

  const getColumns = () => {
    const { formatMessage: translate } = intl;

    return [
      {
        displayName: translate({ id: 'dashboard.installedAtsTable.SAP_NO_COL' }),
        fieldName: 'number',
        width: '120px',
        renderFn: row => <SapId originalId={row.number}>{id => <>{id}</>}</SapId>,
      },
      {
        displayName: translate({ id: 'dashboard.installedAtsTable.NAME_COL' }),
        fieldName: 'name',
        width: '330px',
        tooltip: row => row.name,
      },
      {
        displayName: translate({ id: 'dashboard.installedAtsTable.NAME2_COL' }),
        fieldName: 'name2',
        width: '240px',
        tooltip: row => row.name2,
      },
      {
        displayName: translate({ id: 'dashboard.installedAtsTable.STREET_COL' }),
        fieldName: 'street',
        width: '220px',
        tooltip: row => row.street,
      },
      {
        displayName: translate({ id: 'dashboard.installedAtsTable.HOUSE_NO_COL' }),
        fieldName: 'houseNumber',
        width: '120px',
      },
      {
        displayName: translate({ id: 'dashboard.installedAtsTable.POSTAL_CODE_COL' }),
        fieldName: 'postalCode',
        width: '120px',
      },
      {
        displayName: translate({ id: 'dashboard.installedAtsTable.CITY_COL' }),
        fieldName: 'city',
        width: '160px',
      },
      {
        displayName: translate({ id: 'dashboard.installedAtsTable.#_EQUIPMENT_COL' }),
        fieldName: 'equipmentCount',
        width: '110px',
      },
      {
        displayName: translate({ id: 'dashboard.installedAtsTable.#_SERVICES_COL' }),
        fieldName: 'serviceCount',
        width: '110px',
      },
      {
        displayName: translate({
          id: 'dashboard.installedAtsTable.#_CONTRACT_LINES_COL',
        }),
        fieldName: 'contractCount',
        width: '110px',
      },
    ];
  };

  const handleRowClick = (id) => {
    history.push(`/installedat/${id}`, { context: id });
  };

  const renderHeader = () => <ThemeHeader inlineTable={true} height='50px'>
    <span>
      {intl.formatMessage({
        id: 'dashboard.installedAtsTable.TABLE_TITLE',
      })}
      ({data.length})
      <EquipmentCount>
        ({equipmentCount}{' '}
        {intl.formatMessage({
          id: 'dashboard.installedAtsTable.EQUIPMENT_LABEL',
        })}
        )
      </EquipmentCount>
      <Filter>
        {intl.formatMessage({
          id: 'dashboard.installedAtsTable.EMPTY_EQUIPMENT_TOGGLE',
        })}
        <StyledSwitch
          checked={showEmptyEquipment}
          onChange={() => setShowEmptyEquipment(s => !s)}
        />
      </Filter>
    </span>
  </ThemeHeader>;

  return (
    <Wrapper>
      <Table
        renderCustomHeader={renderHeader}
        usePaging={true}
        fullWidth={true}
        columns={getColumns()}
        data={data}
        isLoading={isLoading}
        onRowClick={handleRowClick}
        activeRow={activeRow}
        lightHeader={true}
      />
    </Wrapper>
  );
};

InstalledAtsTable.propTypes = {
  isLoading: PropTypes.bool,
  installedAts: PropTypes.array,
  equipmentCount: PropTypes.number,
  intl: PropTypes.object,
  history: PropTypes.object.isRequired,
  activeRow: PropTypes.object,
};

export default withRouter(injectIntl(InstalledAtsTable));
